import React from 'react';

import { Box, Grid, Text, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/hooks/useAuth';

import LangSwitcher from '@/components/LangSwitcher';
import { MarketingCheckbox } from '@/components/Layout/SidebarBottom/MarketingCheckbox';

import { RoutesEnum } from '@/enums/routes.enum';

import { tKeys } from '@/i18n/resourses';

import { List, StyledLink } from './SidebarBottom.styles';

const SidebarBottom = () => {
  const { t } = useTranslation();
  const { jwt, username, onLogout } = useAuth();

  const links: Array<{ label: string; href: string }> = [
    {
      label: t(tKeys.rules),
      href: RoutesEnum.rules,
    },
    {
      label: t(tKeys.howToPlay),
      href: RoutesEnum.help,
    },
  ];

  return (
    <Box color="white" mt="30px" position="relative">
      {jwt && (
        <Grid gap="16px" my="24px">
          <Text fontSize="16px" fontWeight={600}>
            {username}
          </Text>

          <Grid gap={'8px'} my="10px">
            <Text fontSize="16px" fontWeight={600}>
              Preferences
            </Text>

            <MarketingCheckbox />
          </Grid>
        </Grid>
      )}

      <List>
        {links.map((item, id) => (
          <li key={id}>
            <StyledLink to={item.href}>{item.label}</StyledLink>
          </li>
        ))}
        <div style={{ width: '100px', margin: '0 auto' }}>
          <LangSwitcher />
        </div>
        {jwt && (
          <Button
            onClick={onLogout}
            textTransform="uppercase"
            variant="primary"
          >
            {t(tKeys.logout)}
          </Button>
        )}
      </List>
    </Box>
  );
};

export default SidebarBottom;
